module.exports = __webpack_public_path__ + "img/book.43862e82.png";